import { render, staticRenderFns } from "./InvoiceOverdueNoticesForm.vue?vue&type=template&id=af72b302&scoped=true&"
import script from "./InvoiceOverdueNoticesForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOverdueNoticesForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceOverdueNoticesForm.vue?vue&type=style&index=0&id=af72b302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af72b302",
  null
  
)

export default component.exports